export default __webpack_public_path__ + "static/short-lets-6f2dec67294eeb67d17a7689dca9f17f.png";